import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';

import Title from '../Components/Title'


import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    HiddenTransform
} from '../../components';

import {
    Card
} from '../../components'

import PurchaseInput from '../Components/PurchaseInput'

import {useEffect, useState} from 'react'

import {
    useSilver
} from '../../context/silver'

import {
    useGoldVIP,
    useBuyGoldPostion,
    useHarvest
} from '../../hook/silver/useGold'
import { EtherToInt } from '../../ethers/e';

import CountdownMemo from '../Components/Countdown'
import { useTranslation } from 'react-i18next';

import {
    CheckProtocal
} from '../Protocol'


function Harvest() {
    return <Button style={{height: "min-content"}} {...useHarvest()} />
}

function Index() {
    const user = useSilver()
    const gold = user.gold
    const {t} = useTranslation()
   
    
    return (
        <Container>
            <WhiteSpace size={.4}/>
            <Title src='/icon/au.png'>
                <TextXL style={{lineHeight: '22px'}} >GODL<TextM style={{marginLeft: '10px'}} color='2'>{t('Asset Portfolio')}</TextM></TextXL>
            </Title>
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <WhiteSpace size={.4}/>
                <div style={{textAlign:'center'}}>
                    <TextM color='2'>{t('Cumulative Sales')} USDG</TextM>
                    <WhiteSpace size='0'/>
                    <TextLinear style={{fontSize: '1.8rem'}}>{EtherToInt(user.totalGoldUnlcokableUSDG)}</TextLinear>
                    {/* <TextMax>123321,1231223 </TextMax> */}
                    
                </div>  
                <WhiteSpace size={.6}/>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    divider={<Divider orientation="vertical" flexItem />}
                    style={{
                        background: 'linear-gradient(45deg, rgb(37, 39, 46), rgb(48, 49, 56))',
                        padding: '10px 0px',
                        borderRadius: '14px'
                    }}
                    // spacing={1}
                >
                    <div style={{textAlign:'center', width:'100%'}}>
                        <TextS color='2'>{t('Settlement')}</TextS>
                        <br />
                        <TextL>7D</TextL>
                    </div>
                    <div style={{textAlign:'center', width:'100%'}}>
                        <TextS color='2'>{t('Fundraising')}</TextS>
                        <br />
                        <TextL>5H</TextL>
                    </div>
                    <div style={{textAlign:'center', width:'100%'}}>
                        <TextS color='2'>{t('Yield')}</TextS>
                        <br />
                        <TextL>3.6%</TextL>
                    </div>
                </Stack>
                <WhiteSpace size={.8}/>
                <CheckProtocal>
                    {
                        !gold.vip ?
                        <UpgradeToVIP usdgBalance={user.usdtBalance}/> :
                        <PurchaseBlock usdgBalance={user.usdgBalance}/>
                    }
                </CheckProtocal>
            </Card>
            <WhiteSpace size={1.6}/>
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <div>
                        <TextM>{t('My Unlocked')} USDG</TextM>
                        <br />
                        <TextLinear style={{fontSize: '1.6rem'}}>{EtherToInt(gold.totalUnlockable)}</TextLinear>
                    </div>
                    <Harvest />
                </Stack>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />

                {/* <TextS color='2'>Harvest Fee Rate 0.05%</TextS> */}
                {/* <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <TextS color='2'>Harvest Fee Rate</TextS>
                    <TextS>0.05%</TextS>
                </Stack> */}
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <TextS color='2'>{t('Total Reward')} USDG</TextS>
                    <TextS>{EtherToInt(gold.totalLocked)}</TextS>
                </Stack>

                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <TextS color='2'>{t('Total Funds')} USDG</TextS>
                    <TextS>{EtherToInt(gold.totalFunds)}</TextS>
                </Stack>

                
                {/* <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <TextS color='2'>Team Contribution USDG</TextS>
                    <TextS>{EtherToInt(gold.teamPerformance)}</TextS>
                </Stack> */}
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <GoldPostion position={gold.position}/>
            </Card>
        </Container>
    )
}

export default Index


function GoldPostion({position}) {
    const [table, setTable] = useState(2)
    const {t} = useTranslation()

    return (
        <>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems='center'
            >
                <TextM>{t('My Position')}</TextM>
                <div>
                    <TextS
                        style={{padding: '3px 6px'}}
                        onClick={() => {
                            setTable(2)
                        }}
                        color={table===2?'1':'2'}
                    >{t('Releasing')}</TextS>
                    <TextM color='2'>|</TextM>
                    <TextS
                        style={{padding: '3px 6px'}}
                        onClick={() => {
                            setTable(1)
                        }}
                        color={table===1?'1':'2'}
                    >{t('Ended')}</TextS>
                </div>
            </Stack>
            {
                position
                .filter(v => {
                    // 1 releaved | 0 freezen | 2 releaving
                    let filter;
                    if (table === 2) {
                        filter = v.status === 2 || v.status === 0 
                    } else  {
                        filter = v.status === 1
                    }
                    return filter
                })
                .sort((a,b) => b.pId - a.pId)
                .map(v => (
                    <div key={v.pId}>
                        <WhiteSpace />
                        <Hr />
                        <WhiteSpace />
                        <Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS color='2'>
                                    <TextS
                                        style={{
                                            display: 'inline-block',
                                            /* height: 40px; */
                                            /* line-height: 47px; */
                                            background: '#f8d83a',
                                            textAlign: 'center',
                                            padding: '0px 8px',
                                            borderRadius: '8px',
                                            marginRight: '4px',
                                            color: 'rgb(36 38 47)'
                                        }}
                                    >{v.pId + 1}</TextS>
                                    {t('Total Locked')} USDG
                                </TextS>
                                <TextS>{EtherToInt(v.locked)}</TextS>
                            </Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS style={{marginLeft: '28px'}} color='2'>{v.status === 0 ? t('Released USDG'): t('Principal')}</TextS>
                                {
                                    v.status === 2 ? 
                                    <CountdownMemo end={v.endTime*1000} />:
                                    v.status === 1 ? 
                                    <TextS>{EtherToInt(v.locked / 1.036)}</TextS>:
                                    <CountdownMemo end={v.freezenTime*1000} />
                                }
                            </Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS
                                    style={{marginLeft: '28px'}} 
                                    color='2'
                                >
                                    {t('Ended Time')} USDG
                                </TextS>
                                <TextS>{v.endDate}</TextS>
                            </Stack>
                            
                        </Stack>
                    </div>
                ))
            }
        </>
    )
}


function PurchaseBlock({usdgBalance}) {
    const [open,setOpen] = useState(false)

    const {
        inputAmount,
        inviter,
        button
    } = useBuyGoldPostion()

    useEffect(() => {
        if (inviter === -1) setOpen(false)
    }, [inviter])
    const {t} = useTranslation()

    return (
        <>  
            <HiddenTransform open={!open}>
                <Button
                    style={{
                        // position: 'absolute',
                        // left: '50%',
                        // top: '-2px',
                        width: '100%',
                        // marginLeft: '-70px',
                        padding: '6px 0px',
                        fontSize: '.8rem',
                        zIndex: 1
                    }}
                    type='b'
                    onClick={()=>{
                        setOpen(!open)
                    }}
                >{t('Purchase')}</Button>
                <WhiteSpace size={1}/>
            </HiddenTransform>
            <HiddenTransform open={open}>
                <WhiteSpace size={1}/>
                <Hr />
                <WhiteSpace size={.8}/>
                <PurchaseInput
                    slider
                    input={inputAmount}
                    balance = {{
                        token: 'USDG',
                        amount: usdgBalance,
                        max: usdgBalance
                    }}
                />
                <TextS style={{margin:'16px 0px', display: 'block'}} color='2'>{t('Minimum Input')} 200,000 USDG</TextS>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <Button type='f' style={{width:'25%'}} onClick={()=> setOpen(!open)}>{t('Cancel')}</Button>
                    <Button
                        style={{width:'72%'}}
                        disabled={inputAmount.value*1 > usdgBalance*1}
                        {...button}
                    />
                </Stack>
            </HiddenTransform> 
        </>
    )
}

function UpgradeToVIP({balance}) {
    const disabled=balance*1 < 200000
    const button = useGoldVIP()
    const {t} = useTranslation()
    return (
        <div style={{textAlign:'center'}}>
            <TextS style={{marginTop: '12px'}}>{t('Balance')} {EtherToInt(balance)} USDT</TextS>
            <Button disabled={disabled} style={{width:'100%'}} {...button}/>
            <TextS style={{marginTop: '12px'}} color='2'>200,000 USDT {t('for Upgrade')} VIP</TextS>
        </div>
    )
}

// const BackLine = styled('div')`
//     position: relative;
//     width: 100%;
//     ::before {
//         content: '';
//         position: absolute;
//         left: 0;
//         top: 50%;
//         width: 100%;
//         background-color: #ddd;
//         height: 1px;
//         z-index: -1;
//     }
// `